import type { FormSubmission } from '../types';

export const searchEstimations = (submissions: FormSubmission[], query: string): FormSubmission[] => {
  if (!query.trim()) return submissions;

  const searchTerm = query.toLowerCase().trim();

  return submissions.filter((submission) => {
    const searchableFields = [
      submission.nom || '',
      submission.prenom || '',
      submission.email || '',
      submission.telephone || '',
      submission.id || '',
      submission.created_at ? new Date(submission.created_at).toLocaleDateString('fr-FR') : ''
    ];

    return searchableFields.some(
      (field) => field && field.toString().toLowerCase().includes(searchTerm)
    );
  });
};